export const getDoctype = (doc: Document): string => {
  const doctypeObj = doc.doctype;
  return `<!DOCTYPE ${doctypeObj?.name ?? 'html'}${doctypeObj?.publicId ? ` PUBLIC "${doctypeObj.publicId}"` : ''}${
    !doctypeObj?.publicId && doctypeObj?.systemId ? ' SYSTEM' : ''
  }${doctypeObj?.systemId ? ` "${doctypeObj.systemId}"` : ''}>`;
};
